import React, { useState } from "react";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import useFetch from "../../../../context/useFetch";

const RemoveOrder = (props) => {
  const [openModal, setOpenModal] = useState(false);

  const updateOrderApi = useFetch({
    method: "patch",
    url: `Order_Service/${props.selectedRow?.id}/cancel_order`,
    trigger: false,
    data: { state: "cancel" },
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  لغو شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false);
      props.getCreateOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const customer_change_order_to_on_cancle = () => {
    updateOrderApi.reFetch();
  };

  return (
    <>
      <TableIconModal
        width="w-2/5"
        isRemove={true}
        removeText="آیا از حذف سفارش اطمینان دارید؟"
        icon={<DeleteIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleRemoveOnClick={customer_change_order_to_on_cancle}
      ></TableIconModal>
    </>
  );
};
export default RemoveOrder;
